import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavService {
  private _navItemSource = new BehaviorSubject<any>(0);
  private _navHeaderObjSource = new BehaviorSubject<any>(location.hash.replace('#', ''));
  private _navPlayerDrpDwn = new BehaviorSubject<any>(0);
  private _navPlatformandSport = new BehaviorSubject<any>(0);
  private _navGetPlayersId = new BehaviorSubject<any>(0);
  navItem$ = this._navItemSource.asObservable();
  navObj$ = this._navHeaderObjSource.asObservable();
  navPlayerObj$ = this._navPlayerDrpDwn.asObservable();
  navPlatformSportObj$ = this._navPlatformandSport.asObservable();
  navGetPlayersIdValue$ = this._navGetPlayersId.asObservable();

  changeNav(any) {
    this._navItemSource.next(any);
  }

  changeNavHeaderActive(any) {
    this._navHeaderObjSource.next(any);
  }

  changedSlateDrpDwn(any) {
    this._navPlayerDrpDwn.next(any);
  }

  onPlatformandSportChange(any) {
    this._navPlatformandSport.next(any);
  }

  getPlayerId(any) {
    this._navGetPlayersId.next(any);
  }

  constructor() { }
}
